import arrayMove from "array-move";
import React, { useState } from "react";
import SortableList, { SortableItem } from "react-easy-sort";
import { Card, CardBody, Col, Row } from "reactstrap";

const TestSortable = () => {
  const [items, setItems] = useState([
    { id: "1", name: "Module 1" },
    { id: "2", name: "Module 2" },
    { id: "3", name: "Module 3" },
  ]);

  const onSortEnd = (oldIndex, newIndex) => {
    setItems(array => arrayMove(array, oldIndex, newIndex));
  };

  return (
    <div className="page-content">
        <div className="container-fluid">
        <SortableList
      onSortEnd={onSortEnd}
      className="list"
      draggedItemClassName="dragged"
    >
      {items.map((item) => (
        <SortableItem key={item?.id}>
          <div className="item">{item?.name}</div>
        </SortableItem>
      ))}
    </SortableList>
    </div>
    </div>
  );
};

export default TestSortable;